module.exports = __webpack_public_path__ + "img/extension_polist.8f2cb520.png";